import React from 'react';
import GestionAbstract from '../../components/forms/gestion-abstract';
import ITypeTransport from '../../models/ITypeTransport';
import Guid from '../../models/Guid';
import IBaseModel from '../../models/IBaseModel';

interface IGestionTypesTransportsProps {
  isModeSelection?: boolean;
}

class TypeTransport extends IBaseModel implements ITypeTransport {
  idTypeTransport: Guid = Guid.empty;
  actif: boolean = false;
}

export default function GestionTypesTransports({ isModeSelection }: IGestionTypesTransportsProps) {
  return (
    <GestionAbstract isModeSelection={isModeSelection} path="TypeTransport" model={TypeTransport} descriptionOptions={{ maxLength: 50 }} />
  );
}